import { useState, type CSSProperties } from "react";
import { Pill } from "../primitives";
import { useSessionScope } from "../../hooks/use-session-scope";
import { ScopePickerModal } from "./ScopePickerModal";

export function CockpitScopeChip() {
  const { scope, clearScope } = useSessionScope();
  const [pickerOpen, setPickerOpen] = useState(false);

  const label = scope.length > 0
    ? scope.length === 1
      ? scope[0]!.type
      : `${scope.length} scoped`
    : "no scope";

  return (
    <>
      <Pill
        variant={scope.length > 0 ? "blue" : "gray"}
        icon="focus-2"
        onClick={() => setPickerOpen(true)}
      >
        {label}
        {scope.length > 0 && (
          <span
            role="button"
            tabIndex={0}
            onClick={(e) => { e.stopPropagation(); clearScope(); }}
            onKeyDown={(e) => e.key === "Enter" && (e.stopPropagation(), clearScope())}
            style={clearBtn}
            title="Clear scope"
          >
            <i className="ti ti-x" style={{ fontSize: 10 }} aria-hidden="true" />
          </span>
        )}
      </Pill>
      <ScopePickerModal open={pickerOpen} onClose={() => setPickerOpen(false)} />
    </>
  );
}

const clearBtn: CSSProperties = {
  marginLeft: 2,
  cursor: "pointer",
  display: "inline-flex",
  alignItems: "center",
  opacity: 0.7,
};
